"use client";
import { getS3ImageUrl, homePageRoutePath } from "@/utils/routes";


import Image from "next/image";
import Link from "next/link";
import { useEffect, useRef, useState } from "react";
import classes from "./AllCategoriesSection.module.css";

import useCategoriesById from "@/hooks/useCategoriesById";
import { placeholderImage } from "@/utils/constants";

import { Grid, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import { getSectionStyle } from "@/utils";
import "swiper/css";
import "swiper/css/grid";
import "swiper/css/pagination";

interface Props extends WidgetSectionProps {
  category?: number[];
  sectionHeader?: SectionHeaderType;
  renderLoad?: boolean;
  id?: string;
}

interface CategoryItemsType {
  img: string;
  title: string;
  slug?: string;
}

interface CategoryProps extends CategoryItemsType {
  className?: string;
}

interface CategoryGridProps {
  items: CategoryItemsType[];
  className?: string;
}

const CategoryCard = ({ img, title, slug, className }: CategoryProps) => {
  return (
    <Link href={homePageRoutePath + "/category/" + slug} passHref>
      <div
        className={`${classes.CategoryCard} ${className}`}
        style={{
          cursor: "pointer",
        }}
      >
        <div className={classes.top}>
          <Image
            src={img}
            alt={title??'category image'}
            blurDataURL={
              "https://www.unfe.org/wp-content/uploads/2019/04/SM-placeholder.png"
            }
            placeholder="blur"
            width={100}
            height={100}
            layout="responsive"
            objectFit="contain"
            className={classes.image}
            unoptimized={true}
            style={{
              aspectRatio: 1,
              objectFit: "contain",
            }}
          />
        </div>

        <div className={classes.bottom}>
          <h4 className={classes.title}>
            {title}
            <br />
            <br />
          </h4>
        </div>
      </div>
    </Link>
  );
};

const AllCategoriesSection = ({ widget }: Props) => {
  const mainRef = useRef(null);

  

  const { categories, loading, error } = useCategoriesById({
    widget: widget,
  });


  const [windowWidth, setWindowWidth] = useState<number>(0);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if ((!categories || categories.length === 0) && !loading) return null;

  const settings = widget?.data?.settings || {};

  // console.log({categories});
  
  return (
    <div
      ref={mainRef}
      className={classes.AllCategoriesSection}
      style={getSectionStyle(settings)}
    >
      {/* <div className="container grid grid-cols-3 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-7 justify-center items-center"> */}
      {/* <div className={`${classes.categories} container`}>
                {categories?.map((item, i) => (
                    <CategoryCard
                        key={category.id || category.slug || `cat-${i}`}
                        img={item.logo ? getS3ImageUrl(item.logo) : placeholderImage}
                        slug={item.slug}
                        title={item.name}
                        className={classes.categoryCard}
                    />
                ))}
            </div> */}

      <div className={`${classes.container} container`}>
        <Swiper
          key={windowWidth}
          slidesPerView={3}
          breakpoints={{
            320: {
              slidesPerView: 4,
            },
            640: {
              slidesPerView: 5,
            },
            768: {
              slidesPerView: 6,
            },
            1024: {
              slidesPerView: 7,
            },
            1280: {
              slidesPerView: 8,
            },
          }}
          grid={{
            rows: 2,
            fill: "row",
          }}
          spaceBetween={16}
          pagination={{
            clickable: true,
          }}
          modules={[Grid, Pagination]}
          className="mySwiper !pb-8"
        >
          {categories?.map((item) => (
            <SwiperSlide key={item.id || item.slug || `cat-swiper-${item.name}`}>
              <CategoryCard
                key={item.id || item.slug || `cat-card-${item.name}`}
                img={item.logo ? getS3ImageUrl(item.logo) : placeholderImage}
                slug={item.slug}
                title={item.name}
                className={classes.categoryCard}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default AllCategoriesSection;
